export default "__VITE_ASSET__Cf6c2ixG__"